/*

Usage:

ES6:
import VueClosable from 'vue-closable'
Vue.use(VueClosable)

ES5:
var VueClosable = require('vue-closable')
Vue.use(VueClosable)

template:
<div
  v-closable="{
	handler: 'onClose'
	exclude: ['fooElementRef', 'barElementRef*'],
	include: ['fooInsideElementRef']
  }"
>
...
</div>

exclude - the list of the refs, which exclude from detection
include - the list of the refs, which includes to detection in spite of they are placed inside excluded element
if no "*" marker after ref name - it means use only this ref, else use this element and all inside it
*/
let vueClosable = {};

vueClosable.install = function ( Vue ) {
	let handle;
	
	Vue.directive(
		"closable",
		{
			bind( el, binding, vnode ) {
				handle = ( e ) => {
					const excluded =
						binding.value.exclude
						?
						binding.value.exclude.find(
							item => {
								const contains = item.endsWith("*");
								if ( contains ) item = item.slice( 0, -1 );
								let iEl = vnode.context.$refs[ item ];
								if ( iEl instanceof Vue ) iEl = iEl.$el;
								
								return iEl && ( contains ? iEl.contains( e.target ) : iEl === e.target );
							}
						) !== undefined
						:
						undefined;

					const included =
						binding.value.include
						?
						binding.value.include.find(
							item => {
								const contains = item.endsWith("*");
								if ( contains ) item = item.slice( 0, -1 );
								let iEl = vnode.context.$refs[ item ];
								if ( iEl instanceof Vue ) iEl = iEl.$el;
								
								return iEl && ( contains ? iEl.contains( e.target ) : iEl === e.target );
							}
						) !== undefined
						:
						undefined;

					if ( !el.contains( e.target ) || excluded === false || included === true ) {
						e.stopPropagation();
						vnode.context[ binding.value.handler ]();
					}
				};
				
				document.addEventListener( "click", handle );
				document.addEventListener( "touchstart", handle );
			},
			
			unbind() {
				document.removeEventListener( "click", handle );
				document.removeEventListener( "touchstart", handle );
			}
		}
	);
};

if ( typeof window !== "undefined" && window.Vue ) {
	window.Vue.use( vueClosable )
}

export default vueClosable;